/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-02 20:01:10
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-08-29 16:44:59
 */
import { Popover, Divider } from '@didi-pebble/pebble-design-react';
import { useAtomValue } from 'jotai';
import { i18nTranslate } from '@didi/i18n-plugin';

import { PASSPORT } from '@/config';
import { loginInfoAtom } from '@/store/common';
import { ReactComponent as Header } from '@/assets/images/header.svg';
import { ReactComponent as ArrowDown } from '@/assets/images/arrow_down.svg';
import goPassport from '@/lib/passport';

import styles from './index.module.less';

const UserInfo: React.FC = () => {
  const loginInfo: any = useAtomValue(loginInfoAtom);
  const dropdownMenu = (
    <>
      <div className='flex flex-col items-center'>
        <Header width={48} height={48} />
        <span className='mt-[8px] font-DiDiSansPro-Medium text-sm text-center'>
          {loginInfo?.email}
        </span>
      </div>
      <div className='flex flex-col'>
        <Divider style={{ marginTop: 8, marginBottom: 0 }} />
        <span
          className='px-[16px] py-[9px] my-[3px] cursor-pointer hover:bg-[#FFF7F2] hover:text-orange-500'
          onClick={() => {
            setTimeout(() => {
              goPassport(PASSPORT.logout);
            }, 20);
          }}
        >
          {i18nTranslate('GDriver_B_OZRC_vJMU')}
        </span>
      </div>
    </>
  );

  return (
    <Popover
      getPopupContainer={(triggerNode: any) => triggerNode.parentElement as any}
      overlayClassName={`w-[240px] shadow-md ${styles.userinfo_popover}`}
      trigger={['click']}
      placement='bottomRight'
      content={dropdownMenu}
    >
      <div className='px-[8px] py-[6px] flex items-center rounded hover:bg-[#dadbe0]'>
        <Header width={20} height={20} />
        <ArrowDown width={14} height={14} className='ml-[8px]' />
      </div>
    </Popover>
  );
};

export default UserInfo;
